"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
var fetchWithNetworkError = require("@uppy/utils/lib/fetchWithNetworkError");
var ASSEMBLIES_ENDPOINT = '/assemblies';
/**
 * A Barebones HTTP API client for Transloadit.
 */

var _headers = /*#__PURE__*/_classPrivateFieldLooseKey("headers");
var _fetchWithNetworkError = /*#__PURE__*/_classPrivateFieldLooseKey("fetchWithNetworkError");
var _fetchJSON = /*#__PURE__*/_classPrivateFieldLooseKey("fetchJSON");
var _reportError = /*#__PURE__*/_classPrivateFieldLooseKey("reportError");
var Client = /*#__PURE__*/function () {
  function Client(_opts) {
    var _this = this;
    _classCallCheck(this, Client);
    if (_opts === void 0) {
      _opts = {};
    }
    Object.defineProperty(this, _fetchJSON, {
      value: _fetchJSON2
    });
    Object.defineProperty(this, _headers, {
      writable: true,
      value: {}
    });
    Object.defineProperty(this, _fetchWithNetworkError, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _reportError, {
      writable: true,
      value: function value(err, params) {
        if (_this.opts.errorReporting === false) {
          throw err;
        }
        var opts = {
          type: params.type
        };
        if (params.assembly) {
          opts.assembly = params.assembly.assembly_id;
          opts.instance = params.assembly.instance;
        }
        if (params.url) {
          opts.endpoint = params.url;
        }
        _this.submitError(err, opts).catch(function () {// not much we can do then is there
        });
        throw err;
      }
    });
    this.opts = _opts;
    if (this.opts.client != null) {
      _classPrivateFieldLooseBase(this, _headers)[_headers]['Transloadit-Client'] = this.opts.client;
    }
    _classPrivateFieldLooseBase(this, _fetchWithNetworkError)[_fetchWithNetworkError] = this.opts.rateLimitedQueue.wrapPromiseFunction(fetchWithNetworkError);
  }
  /**
   * @param  {RequestInfo | URL} input
   * @param  {RequestInit} init
   * @returns {Promise<any>}
   */

  /**
   * Create a new assembly.
   *
   * @param {object} options
   * @param {string|object} options.params
   * @param {object} options.fields
   * @param {string} options.signature
   * @param {number} options.expectedFiles
   */
  _createClass(Client, [{
    key: "createAssembly",
    value: function createAssembly(_ref) {
      var _this2 = this;
      var params = _ref.params,
        fields = _ref.fields,
        signature = _ref.signature,
        expectedFiles = _ref.expectedFiles;
      var data = new FormData();
      data.append('params', typeof params === 'string' ? params : JSON.stringify(params));
      if (signature) {
        data.append('signature', signature);
      }
      Object.keys(fields).forEach(function (key) {
        data.append(key, fields[key]);
      });
      data.append('num_expected_upload_files', expectedFiles);
      var url = new URL(ASSEMBLIES_ENDPOINT, "".concat(this.opts.service)).href;
      return _classPrivateFieldLooseBase(this, _fetchJSON)[_fetchJSON](url, {
        method: 'post',
        headers: _classPrivateFieldLooseBase(this, _headers)[_headers],
        body: data
      }).catch(function (err) {
        return _classPrivateFieldLooseBase(_this2, _reportError)[_reportError](err, {
          url: url,
          type: 'API_ERROR'
        });
      });
    }
    /**
     * Reserve resources for a file in an Assembly. Then addFile can be used later.
     *
     * @param {object} assembly
     * @param {UppyFile} file
     */
  }, {
    key: "reserveFile",
    value: function reserveFile(assembly, file) {
      var _this3 = this;
      var size = encodeURIComponent(file.size);
      var url = "".concat(assembly.assembly_ssl_url, "/reserve_file?size=").concat(size);
      return _classPrivateFieldLooseBase(this, _fetchJSON)[_fetchJSON](url, {
        method: 'post',
        headers: _classPrivateFieldLooseBase(this, _headers)[_headers]
      }).catch(function (err) {
        return _classPrivateFieldLooseBase(_this3, _reportError)[_reportError](err, {
          assembly: assembly,
          file: file,
          url: url,
          type: 'API_ERROR'
        });
      });
    }
    /**
     * Import a remote file to an Assembly.
     *
     * @param {object} assembly
     * @param {UppyFile} file
     */
  }, {
    key: "addFile",
    value: function addFile(assembly, file) {
      var _this4 = this;
      if (!file.uploadURL) {
        return Promise.reject(new Error('File does not have an `uploadURL`.'));
      }
      var size = encodeURIComponent(file.size);
      var uploadUrl = encodeURIComponent(file.uploadURL);
      var filename = encodeURIComponent(file.name);
      var fieldname = 'file';
      var qs = "size=".concat(size, "&filename=").concat(filename, "&fieldname=").concat(fieldname, "&s3Url=").concat(uploadUrl);
      var url = "".concat(assembly.assembly_ssl_url, "/add_file?").concat(qs);
      return _classPrivateFieldLooseBase(this, _fetchJSON)[_fetchJSON](url, {
        method: 'post',
        headers: _classPrivateFieldLooseBase(this, _headers)[_headers]
      }).catch(function (err) {
        return _classPrivateFieldLooseBase(_this4, _reportError)[_reportError](err, {
          assembly: assembly,
          file: file,
          url: url,
          type: 'API_ERROR'
        });
      });
    }
    /**
     * Update the number of expected files in an already created assembly.
     *
     * @param {object} assembly
     * @param {number} num_expected_upload_files
     */
  }, {
    key: "updateNumberOfFilesInAssembly",
    value: function updateNumberOfFilesInAssembly(assembly, num_expected_upload_files) {
      var _this5 = this;
      var url = new URL(assembly.assembly_ssl_url);
      url.pathname = '/update_assemblies';
      var body = JSON.stringify({
        assembly_updates: [{
          assembly_id: assembly.assembly_id,
          num_expected_upload_files: num_expected_upload_files
        }]
      });
      return _classPrivateFieldLooseBase(this, _fetchJSON)[_fetchJSON](url, {
        method: 'post',
        headers: _classPrivateFieldLooseBase(this, _headers)[_headers],
        body: body
      }).catch(function (err) {
        return _classPrivateFieldLooseBase(_this5, _reportError)[_reportError](err, {
          url: url,
          type: 'API_ERROR'
        });
      });
    }
    /**
     * Cancel a running Assembly.
     *
     * @param {object} assembly
     */
  }, {
    key: "cancelAssembly",
    value: function cancelAssembly(assembly) {
      var _this6 = this;
      var url = assembly.assembly_ssl_url;
      return _classPrivateFieldLooseBase(this, _fetchJSON)[_fetchJSON](url, {
        method: 'delete',
        headers: _classPrivateFieldLooseBase(this, _headers)[_headers]
      }).catch(function (err) {
        return _classPrivateFieldLooseBase(_this6, _reportError)[_reportError](err, {
          url: url,
          type: 'API_ERROR'
        });
      });
    }
    /**
     * Get the current status for an assembly.
     *
     * @param {string} url The status endpoint of the assembly.
     */
  }, {
    key: "getAssemblyStatus",
    value: function getAssemblyStatus(url) {
      var _this7 = this;
      return _classPrivateFieldLooseBase(this, _fetchJSON)[_fetchJSON](url, {
        headers: _classPrivateFieldLooseBase(this, _headers)[_headers]
      }).catch(function (err) {
        return _classPrivateFieldLooseBase(_this7, _reportError)[_reportError](err, {
          url: url,
          type: 'STATUS_ERROR'
        });
      });
    }
  }, {
    key: "submitError",
    value: function submitError(err, _temp) {
      var _ref2 = _temp === void 0 ? {} : _temp,
        endpoint = _ref2.endpoint,
        instance = _ref2.instance,
        assembly = _ref2.assembly;
      var message = err.details ? "".concat(err.message, " (").concat(err.details, ")") : err.message;
      return _classPrivateFieldLooseBase(this, _fetchJSON)[_fetchJSON]('https://transloaditstatus.com/client_error', {
        method: 'post',
        body: JSON.stringify({
          endpoint: endpoint,
          instance: instance,
          assembly_id: assembly,
          agent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
          client: this.opts.client,
          error: message
        })
      });
    }
  }]);
  return Client;
}();
function _fetchJSON2() {
  var _classPrivateFieldLoo,
    _this8 = this;
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return (_classPrivateFieldLoo = _classPrivateFieldLooseBase(this, _fetchWithNetworkError))[_fetchWithNetworkError].apply(_classPrivateFieldLoo, args).then(function (response) {
    if (response.status === 429) {
      var _classPrivateFieldLoo2;
      _this8.opts.rateLimitedQueue.rateLimit(2000);
      return (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase(_this8, _fetchJSON))[_fetchJSON].apply(_classPrivateFieldLoo2, args);
    }
    if (!response.ok) {
      var serverError = new Error(response.statusText);
      serverError.statusCode = response.status;
      if (!"".concat(args[0]).endsWith(ASSEMBLIES_ENDPOINT)) return Promise.reject(serverError); // Failed assembly requests should return a more detailed error in JSON.

      return response.json().then(function (assembly) {
        if (!assembly.error) throw serverError;
        var error = new Error(assembly.error);
        error.details = assembly.message;
        error.assembly = assembly;
        if (assembly.assembly_id) {
          error.details += " Assembly ID: ".concat(assembly.assembly_id);
        }
        throw error;
      }, function (err) {
        // eslint-disable-next-line no-param-reassign
        err.cause = serverError;
        throw err;
      });
    }
    return response.json();
  });
}
module.exports = Client;